<template>
  <!-- 确认订单头部 -->
  <div class="main">
    <div class="topbg_box">
      <img src="@/assets/member/topbg.png" alt="" class="top_bg" />
      <img src="@/assets/member/topv.png" alt="" class="top_img" v-if="query.product_type == 3" />
      <img src="@/assets/member/tope.png" alt="" class="top_img" v-else />
    </div>
    <van-nav-bar title="购买会员" left-arrow @click-left="onClickLeft" class="header_">
      <template #left>
        <van-icon name="arrow-left" color="#ffffff" size="24" />
      </template>
    </van-nav-bar>
    <div class="privilege_box">
      <div class="privilege_title jus-center" v-show="query.product_type == 3">
        <div class="line_ line_v_l"></div>
        <div class="title_">筑龙VIP尊享<span class="big_">8</span>大权益</div>
        <div class="line_ line_v_r"></div>
      </div>
      <div class="privilege_title jus-center" v-show="query.product_type == 2">
        <div class="line_ line_e_l"></div>
        <div class="title_ tit_e">
          筑龙E会员尊享<span class="big_">4</span>大权益
        </div>
        <div class="line_ line_e_r"></div>
      </div>
      <div class="privilege" v-if="query.product_type == 2">
        <div class="privilege_cont jus-center">
          <div class="privilege_item" v-for="i in eicons" :key="i.key">
            <img :src="i.img" alt="" class="icon_img" />
            <div class="privilege_item_title" style="color: #dbdbdb">
              {{ i.title }}
            </div>
            <div class="privilege_item_info" style="color: #dbdbdb">
              {{ i.info }}
            </div>
          </div>
        </div>
      </div>
      <div class="privilege" v-else>
        <div class="privilege_cont jus-start">
          <div class="privilege_item" v-for="i in vicons" :key="i.key">
            <img :src="i.img" alt="" class="icon_img" />
            <div class="privilege_item_title">{{ i.title }}</div>
            <div class="privilege_item_info">{{ i.info }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block_">
      <div class="block_tit">开通/续费</div>
      <div class="spec_box">
        <div class="spec_cont jus-start">
          <div class="spec_item jus-center" :class="{ spec_item_active: payQuery.product_id == i.id }" v-for="(i,index) in orderTypes" :key="i.id" @click="chooseSpec(i)">
            <div class="item_content">
              <div class="item_tit">{{ i.title }}</div>
              <div class="item_price">
                ￥<span class="big_price">{{ priceFormat(i.price) }}</span>
              </div>
              <div class="item_info" v-show="query.product_type===3">¥{{ priceFormat(i.day_price) }}/天</div>
              <div class="item_info" v-show="query.product_type===2 &&index">¥{{ priceFormat(i.month_price)}}/月</div>
              <div class="item_info" v-show="query.product_type===2 &&!index"> &nbsp; </div>
            </div>
            <div class="item_badge" v-show="i.re_price && index!==orderTypes.length-1 && query.product_type===3">
              <!-- 续费￥{{
                priceFormat(i.re_price).split(".")[0] + "/" + i.spec_unit
              }} -->
              续费￥288/年
            </div>
            <div class="item_badge" v-show="index===orderTypes.length-2 && query.product_type!==3">
              限时4.7折
            </div>
            <div class="item_badge" v-show="index===orderTypes.length-1 && query.product_type!==3">
              限时4.1折
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block_" v-show="uid < 1">
      <div class="block_tit">学员信息</div>
      <input type="number" class="tel_input" placeholder="请输入手机号" v-model="payQuery.mobile" />
      <div class="input_bottom_text">此手机号将成为您的账号，请谨慎填写</div>
    </div>
    <div class="block_">
      <div class="block_tit">支付方式</div>
      <van-radio-group v-model="payQuery.pay_type" class="pay_type_class">
        <van-cell-group>
          <van-cell clickable v-for="i in payTypeArr" :key="i.id" @click="payQuery.pay_type = i.id" v-show="checkShowPayType(i)">
            <template #title>
              <div class="jus-start pay_type_box">
                <div class="">
                  <img :src="i.h5_pic" alt srcset class="pay_img" />
                </div>
                <div class="custom-title">{{ i.name }}支付</div>
              </div>
            </template>
            <template #right-icon>
              <van-radio checked-color="#EE2E2E" :name="i.id" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="block_">
      <div class="block_tit">支付详情</div>
      <div class="price_bottom_box">
        <div class="jus-spB price_item" v-show="souceMoney>0">
          <div class="price_item_text">原价</div>
          <div class="price_item_text">￥{{souceMoney}}</div>
        </div>
        <div class="jus-spB price_item" v-show="discount_money>0">
          <div class="price_item_text">活动优惠</div>
          <div class="price_item_text">-¥{{discount_money}}</div>
        </div>

        <div class="jus-spB price_item" v-for="(i,idx) in discounts" :key="idx+'22234'">
          <div class="price_item_text">{{ i.name }}</div>
          <div class="price_item_text">-¥{{ i.price }}</div>
        </div>
         <div class="jus-spB price_item" v-show="discount_money>0">
          <div class="price_item_text_big price_item_text">实付</div>
          <div class="price_item_text"><span style="color:#ee2e2e">￥</span>
          <span class="big_red">{{ priceFormat(price) }}</span></div>
        </div>
      </div>
      <!-- <div class="total_price_box jus-end">
        <div>
          合计<span style="color:#ee2e2e">￥</span>
          <span class="big_red">{{ priceFormat(price) }}</span>
        </div>

      </div> -->
    </div>
    <div class="air_block"></div>
    <div class="bottom_btn">
      <div class="jus-center">
        <van-checkbox v-model="isAgreement" shape="square" label-disabled checked-color="#EC2F2E" class="agreement_text">
          <span style="color: #333" class="">同意</span>
          <span @click="clickAgree">《付费协议》</span>
        </van-checkbox>
      </div>
      <div class="btn_" @click="goPay" disabled>
        立即购买¥{{ priceFormat(price) }}
      </div>
    </div>
  </div>
</template>
<script>
import Cookie from "js-cookie";
import {
  getPageOptionMember,
  getOrderCode,
  isSuccessForCode,
} from "@/api/memberApi";
import { Toast } from "vant";
import tool from "@/utils/tools.js";
import isWxMini from "@/utils/isWechat.js";
import Cookies from 'js-cookie'
import { isSuccess } from "@/api/ePayPro.js";

// Android 调用 js初始化
function connectWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    // eslint-disable-next-line no-undef
    callback(WebViewJavascriptBridge);
  } else {
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      function () {
        // eslint-disable-next-line no-undef
        callback(WebViewJavascriptBridge);
      },
      false
    );
  }
}
// 注册回调函数，第一次连接时调用 初始化函数
connectWebViewJavascriptBridge(function (bridge) {
  // 初始化
  bridge.init(function (message, responseCallback) {
    const data = {
      "Javascript Responds": "Wee!",
    };
    responseCallback(data);
  });
  // JS方法名
  bridge.registerHandler("appPaySuccess", function (data, responseCallback) {
    window.appPaySuccess(data);
    responseCallback("appPaySuccess" + data);
  });
});
export default {
  data () {
    return {
      isAgreement: true,
      payType: "",
      isAgree: true,
      query: {
        product_type: 3,
        mobile: "",
      },
      uid: 1,
      price: 0,
      activeTab: 3,
      timer: null,
      payQuery: {
        product_type: 2,
        pay_type: 7, // 支付类型 微信支付 7，支付宝支付 2，京东支付 10
        product_id: "", // 选择的价格类型Id
        fromurl: "",
        mobile: "",
        f_code: "",
      },
      payurl: "",
      vicons: [
        {
          img: require("@/assets/member/vicon1.png"),
          title: "1000场/年",
          info: "专家分享",
          key: "1",
        },
        {
          img: require("@/assets/member/vicon2.png"),
          title: "3000小时",
          info: "精品技能课程",
          key: "2",
        },
        {
          img: require("@/assets/member/vicon3.png"),
          title: "训练营购课",
          info: "专享1折起",
          key: "3",
        },
        {
          img: require("@/assets/member/vicon4.png"),
          title: "10万张高清大图",
          info: "一键下载",
          key: "4",
          eshow: true,
        },
        {
          img: require("@/assets/member/vicon5.png"),
          title: "高速下载",
          info: "全站资料",
          key: "5",
        },
        {
          img: require("@/assets/member/vicon6.png"),
          title: "发帖无审核",
          info: "一键发布",
          key: "6",
          eshow: true,
        },
        {
          img: require("@/assets/member/vicon7.png"),
          title: "150万篇资料",
          info: "免费下载",
          key: "7",
          eshow: true,
        },
        {
          img: require("@/assets/member/vicon8.png"),
          title: "VIP专属社群",
          info: "专属服务",
          key: "8",
          eshow: true,
        },
      ],souceMoney:0,
      deposits: [],
      eicons: [
        {
          img: require("@/assets/member/eicon1.png"),
          title: "150万篇资料",
          info: "免费下载",
          key: "e1",
        },
        {
          img: require("@/assets/member/eicon2.png"),
          title: "10万张高清图",
          info: "一键下载",
          key: "e2",
        },
        {
          img: require("@/assets/member/eicon3.png"),
          title: "发帖无审核",
          info: "发帖轻松过",
          key: "e3",
        },
        {
          img: require("@/assets/member/eicon4.png"),
          title: "E会员专属社群",
          info: "资料抢先得",
          key: "e4",
        },
      ],
      payTypeName: "",
      discount_money:0,
      payTypeArr: [],
      orderTypes: [],
      discounts: [],
      webSocket: null,
    };
  },
  computed: {
    priceFormat () {
      return (p) => (p / 100).toFixed(2);
    },
  },

  beforeCreate () {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f7f7f7");
  },
  created () {
    // socket
    if (this.checkCanUserSocket()) {
      this.createSocket()
    }

    if (!Cookie.get("uid"))
      window.location.href = "/login?redirect=" + window.location.href;
    this.getForm();
    this.getOption();
  },
  mounted () {
    if(this.$route.query.product_type==2){
      document.title = 'E会员'
    }else if(this.$route.query.product_type==3){
      document.title = 'VIP'
    }
   },
  beforeDestroy () {
    if (this.webSocket) {
      this.closeSocket()
    }
  },
  methods: {
    // 判断显示支付方式
    checkShowPayType(i) {
      if (isWxMini) {
        if (i.id === 7) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    // 获取支付页面选项
    // 获取页面
    getOption () {
      getPageOptionMember(this.query).then((res) => {
        if (res.errNo === 0){
          const result = res.result || {}
          const payTypes = result.payTypes || []
          const products = result.products || []
          const money = result.money || {}
          const order_types = money.order_types || []
          this.payTypeArr = payTypes.filter(i => i.id !== 10)// 筛选去掉京东支付
          this.products = products;
          this.orderTypes = order_types;
          this.showDefaultProdcut(order_types)
        }
      });
    },
    // 展示默认项
    showDefaultProdcut(order_types){
      const def_id = this.$route.query.id || ''
      if (order_types.length > 0) {
        if(!(def_id && def_id.length > 0)) {
          // 路由没 id
          if(this.query.product_type == 2) {
            this.chooseSpec(this.orderTypes[this.orderTypes.length - 1])
          } else {
            if (this.orderTypes.length > 1) {
              this.chooseSpec(this.orderTypes[this.orderTypes.length - 2])
            } else {
              this.chooseSpec(this.orderTypes[0])
            }
          }
        } else {
          // 路由有 id
          let obj = order_types.filter(i => i.id == this.$route.query.id)
          if (obj.length > 0) {
            // 如果路由带id和only=1，只显示当前的产品
            if (this.$route.query.only == 1) {
              // 存在 only=1，显示当前id对应产品
              this.orderTypes = obj
            }
            this.chooseSpec(obj[0])
          }else {
            this.chooseSpec(this.orderTypes[0])
          }
        }
      }
    },
    // gopay
    goPay () {
      if (!this.payQuery.pay_type) return Toast("请选择支付方式");
      if (!this.isAgreement) return Toast("请先同意付费协议");
      if (tool.isInApp()) {
        const path =
          "mobile=" +
          this.payQuery.mobile +
          "&product_type=" +
          this.payQuery.product_type +
          "&pay_type=" +
          this.payQuery.pay_type +
          "&product_id=" +
          this.payQuery.product_id +
          "&f_code=" +
          this.payQuery.f_code +
          "&fromurl=" +
          this.payQuery.fromurl;
        this.goAppPay(path);
      } else {
        if (this.checkCanUserSocket() && this.webSocket) {
          // 小程序下单
          this.sendCreateOrderDatas(this.payQuery)
        }
        else{
          getOrderCode(this.payQuery).then((res) => {
            window.location.href = res.result.url;
            // this.payurl = res.result.url
          });
        }
      }
    },
    // 选择规格
    chooseSpec (i) {
      this.$router.replace({
        path:this.$route.path,
        query:{
          product_type:this.query.product_type,
          id:i.id,
          only: this.$route.query.only,
          f:this.$route.query.f
        }
      })
      this.payQuery.product_id = i.id;
      getOrderCode(this.payQuery).then((res) => {
        if (res.errNo === 0) {
          const result = res.result || {}
          this.price = result.money * 100;
          this.discounts = result.discounts
          this.souceMoney = parseFloat(result.souceMoney).toFixed(2)
          this.discount_money = parseFloat(result.discount_money).toFixed(2)
        }
      });
    },
    // 获取来源
    getForm () {
      var url = document.URL;
      var urlArr = []
      if (url.split("?").length > 1) {
        urlArr = url.split("?")[1].split("&");
      }
      urlArr.forEach((i) => {
        var val = i.split("=");
        switch (val[0]) {
          case "product_type":
            this.query.product_type =
              this.payQuery.product_type =
              this.activeTab =
              parseInt(val[1]);
            break;
          case "fromurl":
            this.payQuery.fromurl = urlArr.reduce((p, i) => {
              const reduceItem = i.split("=");
              if (
                reduceItem[0] !== "product_type" &&
                reduceItem[0] !== "fromurl" &&
                reduceItem[0] !== "f_code" &&
                reduceItem[0] !== "f"
              ) {
                return p + "&" + i;
              } else {
                return p;
              }
            }, val[1]);
            break;
          case "f_code":
            this.payQuery.f_code = val[1];
            break;
          case "f":
            this.payQuery.f_code = val[1];
            break;
          default:
            break;
        }
      });
    },
    clickAgree () {
      var type = 2
      if (this.query.product_type == 2) {
        // e会员
        type = 3
      }
      this.$router.push({
        path: "/agreement",
        query: {
          type: type,
        },
      });
    },
    // go APP支付
    goAppPay (url) {
      if (tool.isInIosApp()) {
        window.webkit.messageHandlers.vue_payProduct.postMessage(url);
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "vue_payProduct",
          url,
          function (responseData) {
            // android 返参数接受
          }
        );
      }
    },
    // 返回
    onClickLeft () {
      // 处理APP
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage("");
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "vue_backApp",
            "",
            function (responseData) {
              // android 返参数接受
            }
          );
        }
      } else {
        this.$router.go(-1);
      }
    },
    // 检测是否可以开启socket
    checkCanUserSocket() {
      if (typeof WebSocket === 'undefined') {
        return false
      }
      let uid = Cookies.get('uid')
      if (uid === undefined) {
        return false
      }
      let app_code = Cookies.get('app_code')
      if (isWxMini && app_code) {
        return true
      }
      return false
    },
    // 开启socket
    createSocket() {
      this.webSocket = new WebSocket('wss://m.zhulong.com/wss_socket/')
      this.webSocket.onopen = this.webSocketOnOpen
      this.webSocket.onmessage = this.webSocketGetMessage
      this.webSocket.onerror = this.webSocketOnError
      this.webSocket.onclose = this.webSocketClosed
    },
    // 链接
    webSocketOnOpen(res) {
      console.log('open ',res);
      // 登录
      let loginStr = this.createForSocketMessage('login',null)
      console.log('loginStr ',loginStr);
      this.socketSendDatas(loginStr)
    },
    // 收到消息
    webSocketGetMessage(res) {
      const message = JSON.parse(res.data)
      console.log('收到消息 ',message);
      switch (message.type) {
        case 'login_end':
          console.log('登录成功');
          break;
          case 'mini_memberPaySuccess':
            // 小程序支付成功
            let app_code = Cookies.get('app_code')
            let get_app_code = message.app_code
            if (app_code == get_app_code) {
              let data = JSON.parse(message.data)
              this.socketPaySuccess(data)
            }
            break;
        default:
          break;
      }
    },
    // 失败
    webSocketOnError(res) {
      console.log('失败 ',res);
      this.createSocket()
    },
    // 关闭
    webSocketClosed(res){
      console.log('关闭 ',res);
      if (res.code != 1000) {
        // 非正常关闭
        this.createSocket()
      }
    },
    // 发消息
    socketSendDatas(jsonInfo) {
      this.webSocket.send(jsonInfo)
    },
    // 关闭socket
    closeSocket(){
      this.webSocket.close()
      this.webSocket = null
    },
    // 获取登录的字符串,info：object
    createForSocketMessage(type ,info){
      let uid = Cookies.get('uid')
      let appid = Cookies.get('app_id')
      let agency_id = Cookies.get('agency_id')
      let uidStr = agency_id+'_'+appid+'_'+uid+'_2'
      var login = {
        type: type,
        uid: uidStr
      }
      // 自定义数据
      if (info) {
        login.data = JSON.stringify(info)
      }
      return JSON.stringify(login)
    },
    // 发下单
    sendCreateOrderDatas(query){
      // 区分哪个小程序
      let app_code = Cookies.get('app_code')
      let order = {
        type: 'mini_memberOrderPay',
        app_code: app_code,
        paydata: JSON.stringify(query)
      }
      var infoStr = this.createForSocketMessage('proxy', order)
      console.log(infoStr);
      this.socketSendDatas(infoStr)
    },
    // 小程序支付成功 {odersn: "order12330303"}
    // socketPaySuccess(e) {
    //   console.log(e);
    //   this.$router.go(-1)
    // },
    socketPaySuccess(e) {
      console.log(e);
      let order = e.odersn
      this.jumpSuccess(order)
    },
    //跳转成功页——APP使用
    jumpSuccess (order_sn) {
      console.log('成功order ',order_sn);
      // 检测订单状态
      isSuccess({ order_sn: order_sn }).then((res1) => {
        if (res1.errNo == 0) {
          const result = res1.result || {}
          result.isSuccess = 1
          this.$router.push({
            path: "./paySuccess",
            query: { str: JSON.stringify(res1.result) },
          });
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.price_bottom_box {
  margin: 30px 0;
  // border-bottom: 1px #eee solid;
  // padding-bottom: 30px;
}
.big_red {
    font-size: 40px;
    color: #ee2e2e;
  }
.total_price_box {
  line-height: 60px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  .big_red {
    font-size: 40px;
    color: #ee2e2e;
  }
}
.price_item_text {
  line-height: 60px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}
.price_item_text_big{
  font-size: 34px !important;
}
.main {
  background-color: #f7f7f7;
  overflow-x: hidden;
  padding-bottom: 100px;
  height: calc(100% - 100px);
  .bottom_btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: #fff;
    padding: 20px 30px;
    box-sizing: border-box;
    box-shadow: 0 -6px 8px 0 rgba(0, 0, 0, 0.07);
    .btn_ {
      font-family: PingFangSC-Medium;
      font-size: 36px;
      color: #ffffff;
      letter-spacing: 0;
      border-radius: 999px;
      background-image: linear-gradient(133deg, #e7b575 0%, #cd8332 100%);
      width: 100%;
      text-align: center;
      line-height: 80px;
      margin-top: 30px;
    }
    .agreement_text {
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #ee2e2e !important;
      letter-spacing: 0;
    }
    /deep/.van-checkbox__label {
      color: #ee2e2e;
    }
  }
  .block_ {
    background-color: #fff;
    padding: 30px 30px;
    margin-bottom: 20px;
    .spec_box {
      overflow: hidden;
      padding-top: 20px;
      .spec_cont {
        overflow-x: scroll;
        padding-bottom: 20px;
        .spec_item_active {
          background: #fffaf0 !important;
          border-color: #ffa400 !important;
        }
        .spec_item {
          flex-shrink: 0;
          width: 180px;
          height: 290px;
          border-radius: 20px;
          border: 2px solid #ddd;
          text-align: center;
          position: relative;
          margin-right: 20px;
          .item_content {
            // padding-bottom: 44px;
          }
          .item_tit {
            // font-family: PingFangSC-Medium;
            font-size: 32px;
            color: #333333;
            letter-spacing: 0;
          }
          .item_price {
            font-family: Impact;
            font-size: 28px;
            color: #ee2e2e;
            letter-spacing: 0;
            margin: 20px 0;

            .big_price {
              font-size: 44px;
            }
          }
          .item_info {
            // font-family: PingFangSC-Regular;
            font-size: 28px;
            color: #888888;
            letter-spacing: 0;
          }
          .item_badge {
            position: absolute;
            width: 100%;
            background-image: linear-gradient(-63deg, #c40202 5%, #ed4444 100%);
            border-radius: 0 0 20px 20px;
            bottom: 0;
            // font-family: PingFangSC-Regular;
            font-size: 26px;
            color: #ffffff;
            letter-spacing: 0;
            // line-height: 46px;
          }
        }
      }
    }
    .block_tit {
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #333333;
      letter-spacing: 0.75px;
    }
  }
  .topbg_box {
    position: relative;
    margin-top: -80px;
    .top_bg {
      display: block;
      width: 100%;
      margin: 0;
    }
    .top_img {
      width: calc(100% - 40px);
      position: absolute;
      bottom: -18px;
      left: 20px;
    }
  }
  .privilege_box {
    background-image: linear-gradient(180deg, #a50002 0%, #b80003 100%);
    .privilege {
      overflow: hidden;

      .privilege_cont {
        padding: 30px 0;
        overflow-x: scroll;
        .privilege_item {
          flex-shrink: 0;
          text-align: center;
          width: 170px;
          .icon_img {
            display: block;
            width: 80px;
            margin: 0 auto;
          }
          .privilege_item_title {
            font-family: PingFangSC-Medium;
            font-size: 22px;
            color: #fcc37e;
            letter-spacing: 0;
            margin-top: 10px;
          }
          .privilege_item_info {
            font-family: PingFangSC-Regular;
            font-size: 22px;
            color: #dca372;
            letter-spacing: 0;
          }
        }
      }
    }
    .privilege_title {
      .line_ {
        width: 100px;
        height: 4px;
        margin-top: 20px;
      }
      .line_v_l {
        background-image: linear-gradient(
          90deg,
          rgba(230, 204, 150, 0) 0%,
          #e6cc96 100%
        );
      }
      .line_e_l {
        background-image: linear-gradient(
          90deg,
          rgba(205, 205, 205, 0) 0%,
          #cdcdcd 100%
        );
      }
      .line_e_r {
        background-image: linear-gradient(
          270deg,
          rgba(205, 205, 205, 0) 0%,
          #cdcdcd 99%
        );
      }
      .line_v_r {
        background-image: linear-gradient(
          270deg,
          rgba(230, 204, 150, 0) 0%,
          #e6cc96 100%
        );
      }
      .title_ {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #f4c58c;
        letter-spacing: 0;
        margin: 0 20px;

        .big_ {
          font-size: 56px;
        }
      }
      .tit_e {
        color: #e6e6e6 !important;
      }
    }
  }
  .header_ {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha: 0);
    background-image: linear-gradient(90deg, #d20003 0%, #970002 100%);
    color: #fff !important;
    border: none;
    /deep/.van-nav-bar__title {
      color: #fff;
    }
  }
  .header_::after {
    border: none;
  }
}
.air_block {
  height: 100px;
}
.pay_type_class {
  margin-top: 20px;
  /deep/.van-hairline--top-bottom::after {
    border-width: 0 !important;
  }
  /deep/.van-cell {
    padding: 28px 0;
  }
  /deep/.van-cell::after {
    border: none !important;
  }
}
.pay_img {
  display: inline-block;
  width: 40px;
  margin-right: 20px;
}
.tel_input {
  background: #f3f3f3;
  border-radius: 999px;
  display: block;
  font-size: 30px;
  width: 100%;
  line-height: 70px;
  padding: 0 30px;
  box-sizing: border-box;
  text-align: center;
  margin: 20px 0;
}
.input_bottom_text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
}
.jus-start,
.jus-spB,
.jus-center,
.jus-end {
  display: flex;
  align-items: center;
}
.jus-start {
  justify-content: flex-start;
}
.jus-end {
  justify-content: flex-end;
}
.jus-spB {
  justify-content: space-between;
}
.jus-center {
  justify-content: center;
}
.flex-warp {
  flex-wrap: wrap;
}
</style>
